export default __webpack_public_path__ + "images/522540dc6e4597c916831d8ccd83205a.png";